import { models } from 'powerbi-client';

export const global_settings = {
  personalBookmarksEnabled: true,
  bars: {
    actionBar: { visible: true },
    statusBar: { visible: true },
  },
  url: 'https://app.powerbi.com/reportEmbed?reportId=',
  tokenType: models.TokenType.Aad,
};

export const china_settings = {
  personalBookmarksEnabled: false,
  bars: {
    actionBar: { visible: false },
    statusBar: { visible: false },
  },
  url: 'https://app.powerbi.cn/reportEmbed?reportId=',
  tokenType: models.TokenType.Embed,
};
